<template>
  <div>

    <Modal v-model="show" :width="420" class-name="prompt-model" :closable="flag" :mask-closable="flag">
      <div slot="header">
        <span>{{title}}</span>
      </div>

      <div class="model-main">
        <img src="../../../../static/assets/common/prompt.png" alt="无法加载">
        <p>{{content}}</p>
      </div>

      <div slot="footer">
        <a class="modal-cancel" @click="cancel">{{cancelText}}</a>
        <a class="modal-sure" @click="ok">{{okText}}</a>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: 'SelfConfirm',
    methods: {
      close: function () {
        this.show = false
      },
      ok: function () {
        this.show = false;
        this.okCallback();
      },
      cancel: function () {
        this.show = false;
        this.cancelCallback();
      }
    }
  }

</script>


<style>
  /*模态框样式*/
  .prompt-model .ivu-modal-body {
    padding: 30px 25px;
  }

  /*删除模态框*/
  .prompt-model .model-main {
    text-align: center;
  }

  .prompt-model .model-main>img {
    width: 94px;
    height: 94px;
  }

  .prompt-model .model-main>p {
    font-size: 16px;
    color: #454e66;
    margin-top: 10px;
    word-wrap: break-word;
  }

</style>



// WEBPACK FOOTER //
// src/views/live/common/selfconfirm.vue